<div class="create-parameter-page">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">CREAR PARÁMETRO</h1>
                <p class="page-subtitle text-muted">
                    Registre un nuevo parámetro completando la información básica y estado
                </p>
            </div>
        </div>
    </div>
    <div class="page-content">
        <mat-card class="form-card">
            <mat-card-content>
                <form [formGroup]="parameterForm" (ngSubmit)="onSubmit()">
                    <!-- Información Básica -->
                    <div class="form-section">
                        <h6 class="section-title d-flex align-items-center mb-3">
                            <i class="ri-information-line me-2 text-primary"></i>
                            Información Básica
                        </h6>
                        
                        <div class="form-grid basic-grid">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Clave</mat-label>
                                <input matInput formControlName="key" placeholder="MAX_LOGIN_ATTEMPTS" inputmode="text">
                                <mat-error *ngIf="parameterForm.get('key')?.hasError('required')">
                                    {{ getErrorMessage('key') }}
                                </mat-error>
                                <mat-error *ngIf="parameterForm.get('key')?.hasError('maxlength')">
                                    {{ getErrorMessage('key') }}
                                </mat-error>
                                <mat-error *ngIf="parameterForm.get('key')?.hasError('pattern')">
                                    {{ getErrorMessage('key') }}
                                </mat-error>
                                <mat-hint>Clave única del parámetro en formato SCREAMING_SNAKE_CASE (ej: MAX_LOGIN_ATTEMPTS)</mat-hint>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Valor</mat-label>
                                <input matInput formControlName="value" placeholder="5" inputmode="text">
                                <mat-error *ngIf="parameterForm.get('value')?.hasError('required')">
                                    {{ getErrorMessage('value') }}
                                </mat-error>
                                <mat-error *ngIf="parameterForm.get('value')?.hasError('maxlength')">
                                    {{ getErrorMessage('value') }}
                                </mat-error>
                                <mat-hint>Valor del parámetro</mat-hint>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field full-width">
                                <mat-label>Descripción</mat-label>
                                <textarea matInput formControlName="description" rows="3" placeholder="Descripción del parámetro" inputmode="text"></textarea>
                                <mat-error *ngIf="parameterForm.get('description')?.hasError('maxlength')">
                                    {{ getErrorMessage('description') }}
                                </mat-error>
                            </mat-form-field>

                            <div class="form-field checkbox-field">
                                <mat-checkbox formControlName="isActive" color="primary">
                                    Parámetro Activo
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>

                    <!-- Botones de acción -->
                    <div class="form-actions">
                        <button type="button" mat-button (click)="onCancel()" [disabled]="isLoading">
                            <i class="ri-arrow-left-line me-2"></i>
                            Cancelar
                        </button>
                        <button type="submit" mat-raised-button color="primary" [disabled]="parameterForm.invalid || isLoading">
                            <span *ngIf="!isLoading">
                                <i class="ri-add-line me-2"></i>
                                Crear Parámetro
                            </span>
                            <span *ngIf="isLoading">
                                <i class="ri-loader-4-line animate-spin me-2"></i>
                                Creando...
                            </span>
                        </button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>

